'use strict';

var options2Ctrl = ['$uibModal', "$timeout", "$translate", "dialog", function ($uibModal, $timeout, $translate, dialog) {
    var _this = this;
    _this.editMode = [];

    _this.addOption = function (newValue) {
        _this.options = _this.options || [];
    
        newValue = newValue.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g);
        newValue = newValue || [];
    
        const invalidValues = [];
        // const pattern = /^(?:\$\{[a-zA-Z0-9]+(?:\|[a-zA-Z0-9]+)?\}_)+validador_pm$/;
        const pattern = /^(?:\$\{[a-zA-Z0-9]+(?:\|[a-zA-Z0-9]+)?\}_)+.*$/ // Repeat ${string}_ or ${string|string}_ and finally string and special characters
    
        newValue = newValue.map(function (value) {
            value = value.trim();
            if (pattern.test(value)) {
                return value;
            } else {
                invalidValues.push(value);
                return null;
            }
        }).filter(Boolean);

        if (invalidValues.length > 0) {
            this.errorMessage(
                "Error: Valores inválidos",
                'Los siguientes valores no tienen el formato correcto y no se agregaron: ' + invalidValues.join(', ')
            );
        }
        newValue.forEach(function(value) {
            if (!_this.options.includes(value)) {
                _this.options.push(value);
            }
        });
    
        _this.newOption = null;
    };
    
    _this.edit = function (index) {
        _this.editMode[index] = true;
        $timeout(function () {
            var ele = document.getElementById('chip_item_' + index);
            ele.focus();
        }, 100);
    }
    _this.copyOptions = function () {
        var copyElement = document.createElement("textarea");
        copyElement.style.position = 'fixed';
        copyElement.style.opacity = '0';
        var str = _this.options.reduce(function (acc, val) {
            acc = acc + '"' + val.replace('"', '') + '",';
            return acc;
        }, '')
        str = str.substring(0, str.length - 1);;
        copyElement.textContent = str;
        var body = document.getElementsByTagName('body')[0];
        body.appendChild(copyElement);
        copyElement.select();
        document.execCommand('copy');
        body.removeChild(copyElement);
    };

    _this.removeChip = function (index) {
        _this.options.splice(index, 1);
        if (!_this.options.length > 0) {
            _this.checkbox = false;
        }
    };
    _this.removeAll = function () {
        _this.options = [];
    };

    this.errorMessage = function(title, error) {
        dialog.alert({
            title: title,
            body: error,
            close: $translate.instant("DASHBOARD.CLOSE"),
            size: 'md'
        });
    }
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            options: '=',
            checkbox: '=',
            hidehelp:'=',
            legend: '@',
            help: '@'
            
        },
        replace: true,
        controller: options2Ctrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-builder/options2Directive.html'
    };
};
